import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import messages from './messages';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import style from './style.module.less';

const AdvancedSearchDropdown = ({ options, selectedId, onOptionSelected }) => {
  const selectedOption = options.find((opt) => opt.id === selectedId) || {};
  return (
    <DropdownMenu className={style['dropdown-wrapper']} dropdownMenuShouldHaveWidthOfButton>
      <DropdownMenuToggler className={style['dropdown-toggler']} theme={THEME_CONSTANTS.tertiary}>
        {selectedOption.component || <FormattedMessage {...messages.selectOne} />}
      </DropdownMenuToggler>
      {options.map((option) => (
        <DropdownMenuItem key={option.id} onClick={() => onOptionSelected(option)} selected={option.id === selectedId}>
          {option.component}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

AdvancedSearchDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  selectedId: PropTypes.string.isRequired,
  onOptionSelected: PropTypes.func.isRequired,
};

export default AdvancedSearchDropdown;
